import BuildingListResourceModel from '../../generated/types/model/resource/BuildingListResourceModel';
import ClassListResourcePagingResultModel from '../../generated/types/model/resource/ClassListResourcePagingResultModel';

export default class BuildingListResourceViewModel extends BuildingListResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
